// extracted by mini-css-extract-plugin
module.exports = {"title":"_14a47e7"};